/**
 * CM > IPS > 침입탐지 프로파일 > 시그니처 배포룰
 *
 * @since 2021-09-09
 * @author wj_tams_dev04
 */
import {i18n} from '~/plugins/i18n'
import {SystemApiPrefix as smApiPrefix, CmApiPrefix as cmApiPrefix, ObjectSecProfileApiPrefix as objApiPrefix} from '~/utils/restApi'
import {arraysIntoObject} from '~/utils/common'

class PolicyData {
  constructor (obj, modelType = 'ips') {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_signtr_id')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_signtr_id')) this.modelType = 'ads'
    else this.modelType = modelType
    // this.signtr_opt_cfg_status = this.getValue(obj, ['ngips_signtr_opt_cfg_status'], 'signtr_opt_cfg_status')
    this.prf_id = this.getValue(obj, ['ngips_prf_id', 'ads_ips_prf_id'], 'prf_id')
    this.signtr_opt_use_yn = this.getValue(obj, ['ngips_signtr_opt_use_yn', 'ads_ips_signtr_opt_use_yn'], 'signtr_opt_use_yn')
    this.signtr_cate = this.getValue(obj, ['ngips_signtr_cate', 'ads_ips_signtr_cate'], 'signtr_cate')
    this.signtr_id = this.getValue(obj, ['ngips_signtr_id', 'ads_ips_signtr_id'], 'signtr_id')
    this.signtr_msg = this.getValue(obj, ['ngips_signtr_msg', 'ads_ips_signtr_msg'], 'signtr_msg')
    this.signtr_opt_action = this.getValue(obj, ['ngips_signtr_opt_action', 'ads_ips_signtr_opt_action'], 'signtr_opt_action')
    this.signtr_opt_block_key = this.getValue(obj, ['ngips_signtr_opt_block_key', 'ads_ips_signtr_opt_block_key'], 'signtr_opt_block_key')
    this.signtr_opt_block_tm = this.getValue(obj, ['ngips_signtr_opt_block_tm', 'ads_ips_signtr_opt_block_tm'], 'signtr_opt_block_tm')
    this.signtr_opt_msg = this.getValue(obj, ['ngips_signtr_opt_msg', 'ads_ips_signtr_opt_msg'], 'signtr_opt_msg')
    this.signtr_opt_msg_org = this.getValue(obj, ['ngips_signtr_opt_msg_org', 'ads_ips_signtr_opt_msg_org'], 'signtr_opt_msg_org')
    this.signtr_risk = this.getValue(obj, ['ngips_signtr_risk', 'ads_ips_signtr_risk'], 'signtr_risk')
    this.signtr_effect = this.getValue(obj, ['ngips_signtr_effect', 'ads_ips_signtr_effect'], 'signtr_effect')
    this.signtr_ckc_id = this.getValue(obj, ['ngips_signtr_ckc_id', 'ads_ips_signtr_ckc_id'], 'signtr_ckc_id')
    this.signtr_prtc = this.getValue(obj, ['ngips_signtr_prtc', 'ads_ips_signtr_prtc'], 'signtr_prtc')
    this.category_cate_name = this.getValue(obj, ['ngips_category_cate_name', 'ads_ips_category_name'], 'category_cate_name')
    this.signtr_port_port_src_port = this.getValue(obj, ['ngips_signtr_port_port_src_port', 'ads_ips_signtr_port_port_src_port'], 'signtr_port_port_src_port')
    this.signtr_port_port_dst_port = this.getValue(obj, ['ngips_signtr_port_port_dst_port', 'ads_ips_signtr_port_port_dst_port'], 'signtr_port_port_dst_port')
    this.signtr_opt_direction = this.getValue(obj, ['ngips_signtr_opt_direction', 'ads_ips_signtr_opt_direction'], 'signtr_opt_direction')
    this.signtr_opt_log_use_yn = this.getValue(obj, ['ngips_signtr_opt_log_use_yn', 'ads_ips_signtr_opt_log_use_yn'], 'signtr_opt_log_use_yn')
    this.signtr_opt_dump_use_yn = this.getValue(obj, ['ngips_signtr_opt_dump_use_yn', 'ads_ips_signtr_opt_dump_use_yn'], 'signtr_opt_dump_use_yn')
    this.signtr_opt_mail_use_yn = this.getValue(obj, ['ngips_signtr_opt_mail_use_yn', 'ads_ips_signtr_opt_mail_use_yn'], 'signtr_opt_mail_use_yn')
    this.signtr_opt_alert_use_yn = this.getValue(obj, ['ngips_signtr_opt_alert_use_yn', 'ads_ips_signtr_opt_alert_use_yn'], 'signtr_opt_alert_use_yn')
    this.signtr_opt_alarm_use_yn = this.getValue(obj, ['ngips_signtr_opt_alarm_use_yn', 'ads_ips_signtr_opt_alarm_use_yn'], 'signtr_opt_alarm_use_yn')
    this.signtr_attacker = this.getValue(obj, ['ngips_signtr_attacker', 'ads_ips_signtr_attacker'], 'signtr_attacker')
    this.signtr_threat_id = this.getValue(obj, ['ngips_signtr_threat_id', 'ads_ips_signtr_threat_id'], 'signtr_threat_id')
    this.cfg_layer = this.getValue(obj, ['cfg_layer', 'cfg_layer'], 'cfg_layer')
  }
  getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
  getApiParam () {
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      ret[orgKey] = this[key]
    })
    return ret
  }
  fromAddForm () {
    const addFormKey = [
      'prf_id', 'signtr_id', 'signtr_opt_use_yn', 'signtr_opt_action', 'signtr_opt_block_key',
      'signtr_opt_block_tm', 'signtr_opt_log_use_yn', 'signtr_opt_dump_use_yn', 'signtr_opt_mail_use_yn',
      'signtr_opt_alert_use_yn', 'signtr_opt_alarm_use_yn', 'signtr_opt_direction'
    ]
    const ret = {}
    _.forEach(this.keyList, (key, idx) => {
      const orgKey = this.orgKeyList[idx]
      if (addFormKey.includes(key)) ret[orgKey] = this[key]
    })
    return ret
  }
}

class PolicyAllForm {
  constructor (obj, modelType) {
    if (modelType === 'ips') {
      this.edit_item = `ngips_${obj.edit_item}`
      this.edit_item_value = obj.edit_item_value
      this.ngips_signtr_list = obj.signtr_list
    } else if (modelType === 'ads') {
      this.edit_item = `ads_ips_${obj.edit_item}`
      this.edit_item_value = obj.edit_item_value
      this.ads_ips_signtr_list = obj.signtr_list
    }
  }
}

class ExceptHostAddForm {
  constructor (obj, modelType = 'ips') {
    this.prf_id = obj.prf_id
    this.modelType = modelType
    this.excpt_host_desc = obj.excpt_host_desc // desc
    this.excpt_list = _.cloneDeep(obj.excpt_list) // 출발지, 목적지
    this.policy_list = _.cloneDeep(obj.policy_list)
  }
  getApiParam () {
    if (this.modelType === 'ips') {
      return {
        ngips_prf_id: this.prf_id,
        ngips_signtr_excpt_host_desc: this.excpt_host_desc,
        ngips_signtr_excpt_list: _.map(this.excpt_list, o => {
          return {
            ngips_signtr_excpt_host_src_addr_obj_id: o.src_addr_obj_id,
            ngips_signtr_excpt_host_dst_addr_obj_id: o.dst_addr_obj_id
          }
        }),
        ngips_signtr_list: this.policy_list
      }
    } else if (this.modelType === 'ads') {
      return {
        ads_ips_prf_id: this.prf_id,
        ads_ips_signtr_excpt_host_desc: this.excpt_host_desc,
        ads_ips_signtr_excpt_list: this.excpt_list,
        ads_ips_signtr_list: this.policy_list
      }
    }
    return {}
  }
}

class ExceptHostGetForm {
  constructor (obj) {
    // ips
    if (_.has(obj, 'ngips_signtr_opt_msg')) {
      this.policy_exc_desc = obj.ngips_signtr_opt_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.ngips_signtr_excpt_host_src_addr_obj_id,
          src_ip_ver: o.ngips_signtr_excpt_host_src_ip_ver_type,
          src_name: o.ngips_signtr_excpt_host_src_obj_uname,
          src_type: o.ngips_signtr_excpt_host_src_obj_type,
          dst_addr_obj_id: o.ngips_signtr_excpt_host_dst_addr_obj_id,
          dst_ip_ver: o.ngips_signtr_excpt_host_dst_ip_ver_type,
          dst_name: o.ngips_signtr_excpt_host_dst_obj_uname,
          dst_type: o.ngips_signtr_excpt_host_dst_obj_type
        }
      })
    }
    // ads
    if (_.has(obj, 'ads_ips_signtr_opt_msg')) {
      this.policy_exc_desc = obj.ads_ips_signtr_opt_msg
      this.items = _.map(obj.items, o => {
        return {
          src_addr_obj_id: o.src_addr_obj_id,
          src_ip_ver: o.src_ip_ver_type,
          src_name: o.src_obj_uname,
          src_type: o.src_obj_type,
          dst_addr_obj_id: o.dst_addr_obj_id,
          dst_ip_ver: o.dst_ip_ver_type,
          dst_name: o.dst_obj_uname,
          dst_type: o.dst_obj_type
        }
      })
    }
  }
}

class OtherProfileApplyForm {
  constructor (obj, modelType) {
    if (modelType === 'ips') {
      this.ngips_profile_list = obj.profile_list
      this.ngips_signtr_items = _.mapKeys(obj.signtr_items, (val, key) => {
        return `ngips_${key}`
      })
    }
    if (modelType === 'ads') {
      this.ads_ips_profile_list = obj.profile_list
      this.ads_ips_signtr_items = _.mapKeys(obj.signtr_items, (val, key) => {
        return `ads_ips_${key}`
      })
    }
  }
}

class CategoryFilterData {
  constructor (obj) {
    this.keyList = []
    this.orgKeyList = []
    if (_.has(obj, 'ngips_category_cate_code')) this.modelType = 'ips'
    else if (_.has(obj, 'ads_ips_category_code')) this.modelType = 'ads'
    this.category_cate_code = this.__getValue(obj, ['ngips_category_cate_code', 'ads_ips_category_code'], 'category_cate_code')
    this.category_cate_name = this.__getValue(obj, ['ads_ips_category_name', 'ngips_category_cate_name'], 'category_cate_name')
    this.category_i_cate_code = this.__getValue(obj, ['ads_ips_category_i_code', 'ngips_category_i_cate_code'], 'category_i_cate_code')
    this.category_release_type = this.__getValue(obj, ['ads_ips_category_release_type', 'ngips_category_release_type'], 'category_release_type')
  }
  __getValue (obj, arr, key) {
    this.keyList.push(key)
    this.orgKeyList.push(this.modelType === 'ips' ? arr[0] : arr[1])
    return _.cloneDeep(_.get(_.values(_.pick(obj, [...arr, key])), 0, void 0))
  }
  get () {
    const ret = {}
    _.forEach(this.keyList, key => {
      ret[key] = this[key]
    })
    return ret
  }
}

export const state = () => ({
  dbVersion: null,
  signatureRuleList: [],
  orgSignatureRuleList: [],
  signatureCategory: []
})

export const getters = {
  /**
   * 시그니처 카테고리를 필터로 매핑한다.
   */
  getSignCateRulesOptions (state) {
    return state.signatureCategory.map(cate => ({
      key: cate.category_cate_code,
      value: cate.category_cate_name,
      label: cate.category_cate_name
    })) || []
  }
}

export const mutations = {
  initStore (state) {
    state.dbVersion = null
    state.signatureRuleList = []
    state.orgSignatureRuleList = []
    state.signatureCategory = []
  },
  /**
   * 배포룰 DB 버전을 스토어에 저장한다.
   */
  setDbVersion (state, version) {
    state.dbVersion = version
  },
  /**
   * 전달된 시그니처 규칙 ID를 찾아 스토어에 저장한다.
   */
  setSignatureItem (state, policy) {
    const idx = state.signatureRuleList.findIndex(({signtr_id: id}) => id === policy.signtr_id)

    if (idx > -1) {
      const copy = _.cloneDeep(state.signatureRuleList)
      copy[idx] = policy

      state.signatureRuleList = Object.freeze(copy)
    }
  },
  /**
   * 전달된 시그니처 규칙 ID를 찾아 스토어에 저장한다
   */
  setSignatureItems (state, rules) {
    const copy = _.cloneDeep(state.signatureRuleList)
    _.forEach(rules, (policy) => {
      const idx = state.signatureRuleList.findIndex(({signtr_id: id}) => id === policy.signtr_id)
      if (idx > -1) copy[idx] = policy
    })
    state.signatureRuleList = Object.freeze(copy)
  },
  /**
   * 예외호스트를 저장한다.
   */
  setHostItems (state, rules) {
    const copy = _.cloneDeep(state.signatureRuleList)
    rules = _.map(rules, o => new PolicyData(o).get())
    _.forEach(rules, (policy) => {
      const idx = state.signatureRuleList.findIndex(({signtr_id: id}) => id === policy.signtr_id)
      if (idx > -1) copy[idx].signtr_opt_msg = policy.signtr_opt_msg
    })
    state.signatureRuleList = Object.freeze(copy)
  },
  /**
   * 시그니처 카테고리를 스토어에 초기화한다.
   */
  setSignatureCategory (state, category) {
    const categoryDataList = _.map(category, o => new CategoryFilterData(o).get())
    const ruleCategory = categoryDataList.filter(item => item.category_release_type === 1) || []
    state.signatureCategory = Object.freeze(ruleCategory)
  },
  /**
   * 시그니처 규칙 목록을 스토어에 초기화한다.
   */
  initSignatureRuleList (state, payload) {
    const list = arraysIntoObject(payload.signtr_column_name, payload.signtr_list)
    state.signatureRuleList = Object.freeze(_.map(list, o => new PolicyData(o).get()))
    state.orgSignatureRuleList = _.cloneDeep(state.signatureRuleList)
  },
  /**
   * 시그니처 규칙 목록을 스토어에 초기화한다.
   */
  setSignatureList (state, rules) {
    state.signatureRuleList = Object.freeze(_.cloneDeep(rules))
  }
}

export const actions = {
  /**
   * IPS DB 버전을 가져온다.
   */
  async getDbVersion ({rootState, commit}, {loading = false, successAlert = false, isNotAlert = false} = {}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const dbType = (modelType === 'ips') ? 101 : 201
      const url = `${objApiPrefix}/ips/profiles/config/ips_db_version?device_contents_update_db_type=${dbType}&device_contents_update_db_sub_type=1`
      const {code, result} = await this.$axios.$get(url, {loading, successAlert, isNotAlert})

      if (code === 'ok') {
        commit('setDbVersion', result.contents_version || '')
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 목록을 리턴한다.
   */
  async getSignatureRuleList ({rootState, commit}, {id, loading = true, successAlert = false, isNotAlert = true} = {}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/polices` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/polices`
      const {code, result} = await this.$axios.$get(url, {loading, successAlert, isNotAlert})

      if (code === 'ok') {
        if (modelType === 'ips') commit('initSignatureRuleList', {signtr_column_name: result.ngips_signtr_column_name, signtr_list: result.ngips_signtr_list})
        if (modelType === 'ads') commit('initSignatureRuleList', {signtr_column_name: result.ads_ips_signtr_column_name, signtr_list: result.ads_ips_signtr_list})
        // commit('setDbVersion', result.ips_db_version)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 정책을 설정한다.
   */
  async setSignatureRule ({rootState, state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/polices` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/polices`
      params.items = _.map(params.items, o => new PolicyData(o, modelType).fromAddForm())
      const {code, result} = await this.$axios.$put(url, params, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 정책의 특정 컬럼을 모두 설정한다.
   * params : edit_item: 변경할 컬럼 키
   *          edit_item_value: 변경할 컬럼의 값
   *          edit_item_list: 전체 적용할 리스트 (default: [] > 빈 배열일 경우 리스트 전체적용함)
   */
  async setAllSignatureRule ({rootState, state, commit, dispatch}, {id, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/polices/all` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/polices/all`
      const paramData = new PolicyAllForm(params, modelType)
      const {code, result} = await this.$axios.$put(url, paramData, {loading, successAlert})

      if (code === 'ok') {
        res.result = result

        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 > 필터 > 카테고리 목록을 조회한다.
   */
  async getSignatureCategory ({rootState, commit}, {loading = true, successAlert = false, isNotAlert = true} = {}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/categories` : `${cmApiPrefix}/adsprf/signature/categories`
      const {code, result} = await this.$axios.$get(url, {loading, successAlert, isNotAlert})

      if (code === 'ok') {
        commit('setSignatureCategory', result)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 정책에 적용된 예외 호스트 정보를 조회한다.
   */
  async getExceptHostDatas ({rootState, commit}, {id, policyId, loading = true, isNotAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/polices/${policyId}/exception-hosts` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/polices/${policyId}/exception-hosts`
      const {code, result} = await this.$axios.$get(url, {loading, isNotAlert})

      if (code === 'ok') {
        res.result = new ExceptHostGetForm(result)
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 시그니처 배포룰 정책에 적용된 예외 호스트 정보를 수정한다.
   */
  async setExceptHostDatas ({rootState, dispatch, commit}, {params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const profileId = params.prf_id
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${profileId}/polices/exception-hosts` : `${cmApiPrefix}/adsprf/signature/profiles/${profileId}/polices/exception-hosts`
      const paramData = new ExceptHostAddForm(params, modelType).getApiParam()
      const {code, result} = await this.$axios.$put(url, paramData, {loading, successAlert})

      if (code === 'ok') {
        res.result = result
        if (result.length > 0) {
          commit('setHostItems', result)
        }
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 현재 프로파일의 시그니처 룰을 기본 설정으로 복구한다.
   */
  async resetSignatureRules ({rootState, state, dispatch, commit}, {id, loading = true, menuKey = ''}) {
    const res = {
      code: 'ok'
    }

    try {
      let headers = null

      if (menuKey) {
        headers = {
          'X-Gui-Menu': menuKey
        }
      }
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/default` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/default`
      const {code} = await this.$axios.$put(url, null, {loading, headers, successAlert: true})

      res.code = code
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  },
  /**
   * 전달된 URL에 해당하는 파일 다운로드를 요청한다.
   */
  async getExcelDownload ({rootState, commit}, {id}) {
    const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
    const url = (modelType === 'ips') ? `${smApiPrefix}/signature/profiles/${id}/file` : `${cmApiPrefix}/adsprf/signature/profiles/${id}/file`
    const result = await this.$axios.$file(url, {responseType: 'blob'})
    return result
  },
  /**
   * 시그니처 배포룰 정책을 다른 프로파일에 적용한다.
   */
  async setOtherProfiles ({rootState, state, commit, dispatch}, {signtrId, params, loading = true, successAlert = true}) {
    const res = {
      code: 'ok'
    }

    try {
      const modelType = rootState.cm.objectSecProfile.ips.ipsIDProfileSettings.detectionPolicyProfile.modelType
      const url = (modelType === 'ips') ? `${smApiPrefix}/signature/apply-profiles/polices/${signtrId}` : `${cmApiPrefix}/adsprf/signature/apply-profiles/polices/${signtrId}`
      const paramData = new OtherProfileApplyForm(params, modelType)
      const {code, result} = await this.$axios.$post(url, paramData, {loading, successAlert, alertMsg: i18n.t('msg.updateApply')})

      if (code === 'ok') {
        if (result.msg) {
          res.reason = result.msg
        }
      } else {
        res.code = code
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }

    return res
  }
}
